// // import React, { useState, useEffect  } from 'react';
// // import { useAuth } from '../App';
// // import { Link, useNavigate } from 'react-router-dom';
// // import { Button } from '../components/ui/button';
// // import { Input } from '../components/ui/input';
// // import { Label } from '../components/ui/label';
// // import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
// // import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
// // import { toast } from 'sonner';
// // import { UserPlus, Mail, Lock, User, Phone, MapPin, Euro } from 'lucide-react';
// // import { Turnstile } from "@marsidev/react-turnstile";


// // export default function Register() {
// //   const { axiosInstance } = useAuth();
// //   const navigate = useNavigate();
// //   const [loading, setLoading] = useState(false);
// //   // const [captchaToken, setCaptchaToken] = useState('');

// //   // const handleCaptchaSuccess = (token) => {
// //   //   setCaptchaToken(token);
// //   // };

// //   // window.handleCaptchaSuccess = handleCaptchaSuccess;

// //   const [captchaToken, setCaptchaToken] = useState('');
// //   const [resetKey, setResetKey] = useState(0);

 
 


// //   const [formData, setFormData] = useState({
// //     email: '',
// //     password: '',
// //     first_name: '',
// //     last_name: '',
// //     phone: '',
// //     address: '',
// //     role: 'nurse',
// //     type_tarification: 'fixe',
// //     tarification: {
// //       fixed_price: '',
// //       travel_fee: '',
// //       infirmier: {
// //         weekday_rate: '',
// //         travel_weekday_fee: '',
// //         weekend_rate: '',
// //         travel_weekend_fee: '',
// //         night_week_rate: '',
// //         travel_night_week_fee: '',
// //         night_weekend_rate: '',
// //         travel_night_weekend_fee: '',
// //       },
// //       aide_soignant: {
// //         weekday_rate: '',
// //         travel_weekday_fee: '',
// //         weekend_rate: '',
// //         travel_weekend_fee: '',
// //         night_week_rate: '',
// //         // travel_night_fee: '',
// //         travel_night_week_fee: '',
// //         night_weekend_rate: '',
// //         travel_night_weekend_fee: '',
// //       }
// //     }
// //   });

// //   const isEstablishment = formData.role === 'établissement de santé';

// //   const handleChange = (e, tarifType = null) => {
// //     const { name, value } = e.target;
// //     if (tarifType) {
// //       if (tarifType === 'tarification' && (name === 'fixed_price' || name === 'travel_fee')) {
// //         setFormData({
// //           ...formData,
// //           tarification: { ...formData.tarification, [name]: value }
// //         });
// //       } else {
// //         setFormData({
// //           ...formData,
// //           tarification: {
// //             ...formData.tarification,
// //             [tarifType]: { ...formData.tarification[tarifType], [name]: value }
// //           }
// //         });
// //       }
// //     } else {
// //       setFormData({ ...formData, [name]: value });
// //     }
// //   };

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();
// //     setLoading(true);

// //     console.log("🔍 Token avant submit:", captchaToken); // DEBUG

// //     if (!captchaToken) {
// //       toast.error("Veuillez valider le CAPTCHA..");
// //       setLoading(false);
// //       return;
// //     }

// //     if (formData.role !== 'établissement de santé' && formData.first_name.trim() === '') {
// //       toast.error("Le prénom est obligatoire pour ce rôle.");
// //       setLoading(false);
// //       return;
// //     }

// //     if (formData.last_name.trim() === '') {
// //       toast.error("Le nom est obligatoire.");
// //       setLoading(false);
// //       return;
// //     }

// //     try {
// //       const cleanNumber = (val) => isNaN(parseFloat(val)) ? 0 : parseFloat(val);

// //       const tarifInfirmier = formData.tarification.infirmier || {};
// //       const tarifAide = formData.tarification.aide_soignant || {};

// //       let tarificationPayload = {};

// //       if (formData.type_tarification === 'fixe') {
// //         tarificationPayload = {
// //           infirmier: {
// //             weekday_rate: cleanNumber(tarifInfirmier.weekday_rate),
// //             travel_weekday_fee: cleanNumber(tarifInfirmier.travel_weekday_fee),
// //             weekend_rate: cleanNumber(tarifInfirmier.weekend_rate),
// //             travel_weekend_fee: cleanNumber(tarifInfirmier.travel_weekend_fee),
// //             night_week_rate: cleanNumber(tarifInfirmier.night_week_rate),
// //             travel_night_week_fee: cleanNumber(tarifInfirmier.travel_night_week_fee),
// //             night_weekend_rate: cleanNumber(tarifInfirmier.night_weekend_rate),
// //             travel_night_weekend_fee: cleanNumber(tarifInfirmier.travel_night_weekend_fee),
// //           },
// //           aide_soignant: {
// //             weekday_rate: cleanNumber(tarifAide.weekday_rate),
// //             travel_weekday_fee: cleanNumber(tarifAide.travel_weekday_fee),
// //             weekend_rate: cleanNumber(tarifAide.weekend_rate),
// //             travel_weekend_fee: cleanNumber(tarifAide.travel_weekend_fee),
// //             night_week_rate: cleanNumber(tarifAide.night_week_rate),
// //             travel_night_week_fee: cleanNumber(tarifAide.travel_night_week_fee),
// //             night_weekend_rate: cleanNumber(tarifAide.night_weekend_rate),
// //             travel_night_weekend_fee: cleanNumber(tarifAide.travel_night_weekend_fee),
// //           }
// //         };
// //       } else {
// //         const fixedPrice = cleanNumber(formData.tarification.fixed_price);
// //         const travelFee = cleanNumber(formData.tarification.travel_fee);

// //         const zeroFields = {
// //           weekend_rate: 0,
// //           travel_weekend_fee: 0,
// //           night_week_rate: 0,
// //           travel_night_week_fee: 0,
// //           night_weekend_rate: 0,
// //           travel_night_weekend_fee: 0,
// //         };

// //         tarificationPayload = {
// //           infirmier: { weekday_rate: fixedPrice, travel_weekday_fee: travelFee, ...zeroFields },
// //           aide_soignant: { weekday_rate: fixedPrice, travel_weekday_fee: travelFee, ...zeroFields }
// //         };
// //       }

// //       // const payload = {
// //       //   ...formData,
// //       //   tarification: tarificationPayload,
// //       //   captcha_token: captchaToken,
// //       // };

// //       const payload = {
// //         email: formData.email,
// //         password: formData.password,
// //         first_name: formData.first_name,
// //         last_name: formData.last_name,
// //         phone: formData.phone,
// //         address: formData.address,
// //         role: formData.role,
// //         type_tarification: formData.type_tarification,
// //         tarification: tarificationPayload,
// //         captcha_token: captchaToken,
// //       };

// //       await axiosInstance.post('/auth/register', payload);

// //       toast.success("Inscription réussie ! Attendez l'approbation de l'administrateur.");
// //       navigate('/login');
// //     } catch (error) {
// //       let message = "Échec de l'inscription";
// //       if (error.response?.data?.detail) {
// //         const detail = error.response.data.detail;
// //         if (Array.isArray(detail)) message = detail.map(d => d.msg).join(', ');
// //         else if (typeof detail === 'string') message = detail;
// //         else if (typeof detail === 'object' && detail.msg) message = detail.msg;
// //         else message = JSON.stringify(detail);
// //       }
// //       toast.error(message);
// //     } finally {
// //       setLoading(false);
// //       setCaptchaToken('');
// //       // if (window.turnstile) window.turnstile.reset();
// //       setResetKey(prev => prev + 1);
// //     }
// //   };

// //   return (
// //     <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-amber-50 via-yellow-50 to-orange-50 p-4">
// //       <div className="w-full max-w-2xl">
// //         <div className="text-center mb-8 fade-in">
// //           <h1 className="text-5xl font-bold text-amber-700 mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
// //             Sana-Care
// //           </h1>
// //           <p className="text-lg text-amber-600">Rejoignez notre équipe</p>
// //         </div>

// //         {/* <Card className="glass-card border-amber-200 shadow-xl">
// //          */}
// //          <Card className="glass-card border-amber-200 shadow-xl relative z-50" style={{position: 'relative', zIndex: 50}}>
// //           <CardHeader>
// //             <CardTitle className="text-2xl text-center text-amber-800">
// //               <UserPlus className="inline mr-2 mb-1" size={28} /> Inscription
// //             </CardTitle>
// //             <CardDescription className="text-center">Créez votre compte professionnel</CardDescription>
// //           </CardHeader>

// //           <CardContent>
// //             <form onSubmit={handleSubmit} className="space-y-4">
// //               {!isEstablishment && (
// //                 <div className="space-y-2">
// //                   <Label htmlFor="first_name" className="text-amber-900">Prénom</Label>
// //                   <div className="relative">
// //                     <User className="absolute left-3 top-3 text-amber-600" size={20} />
// //                     <Input
// //                       id="first_name"
// //                       name="first_name"
// //                       placeholder="Jean"
// //                       value={formData.first_name}
// //                       onChange={handleChange}
// //                       required={!isEstablishment}
// //                       className="pl-10 border-amber-300"
// //                     />
// //                   </div>
// //                 </div>
// //               )}

// //               <div className="space-y-2">
// //                 <Label htmlFor="last_name" className="text-amber-900">Nom</Label>
// //                 <div className="relative">
// //                   <User className="absolute left-3 top-3 text-amber-600" size={20} />
// //                   <Input
// //                     id="last_name"
// //                     name="last_name"
// //                     placeholder="Dupont"
// //                     value={formData.last_name}
// //                     onChange={handleChange}
// //                     required
// //                     className="pl-10 border-amber-300"
// //                   />
// //                 </div>
// //               </div>

// //               <div className="space-y-2">
// //                 <Label htmlFor="email" className="text-amber-900">Email</Label>
// //                 <div className="relative">
// //                   <Mail className="absolute left-3 top-3 text-amber-600" size={20} />
// //                   <Input
// //                     id="email"
// //                     name="email"
// //                     type="email"
// //                     placeholder="exemple@gmail.com"
// //                     value={formData.email}
// //                     onChange={handleChange}
// //                     required
// //                     className="pl-10 border-amber-300"
// //                   />
// //                 </div>
// //               </div>

// //               <div className="space-y-2">
// //                 <Label htmlFor="password" className="text-amber-900">Mot de passe</Label>
// //                 <div className="relative">
// //                   <Lock className="absolute left-3 top-3 text-amber-600" size={20} />
// //                   <Input
// //                     id="password"
// //                     name="password"
// //                     type="password"
// //                     placeholder="••••••••"
// //                     value={formData.password}
// //                     onChange={handleChange}
// //                     required
// //                     className="pl-10 border-amber-300"
// //                   />
// //                 </div>
// //               </div>

// //               <div className="space-y-2">
// //                 <Label htmlFor="phone" className="text-amber-900">Téléphone</Label>
// //                 <div className="relative">
// //                   <Phone className="absolute left-3 top-3 text-amber-600" size={20} />
// //                   <Input
// //                     id="phone"
// //                     name="phone"
// //                     placeholder="+32 000000000"
// //                     value={formData.phone}
// //                     onChange={handleChange}
// //                     required
// //                     className="pl-10 border-amber-300"
// //                   />
// //                 </div>
// //               </div>

// //               <div className="space-y-2">
// //                 <Label htmlFor="address" className="text-amber-900">Adresse</Label>
// //                 <div className="relative">
// //                   <MapPin className="absolute left-3 top-3 text-amber-600" size={20} />
// //                   <Input
// //                     id="address"
// //                     name="address"
// //                     placeholder="123 Rue de la Santé, Bruxelles"
// //                     value={formData.address}
// //                     onChange={handleChange}
// //                     required
// //                     className="pl-10 border-amber-300"
// //                   />
// //                 </div>
// //               </div>

// //               <div className="space-y-2">
// //                 <Label htmlFor="role" className="text-amber-900">Rôle</Label>
// //                 <Select
// //                   value={formData.role}
// //                   onValueChange={(value) => setFormData({ ...formData, role: value })}
// //                 >
// //                   <SelectTrigger className="border-amber-300">
// //                     <SelectValue placeholder="Choisissez un rôle" />
// //                   </SelectTrigger>
// //                   <SelectContent>
// //                     <SelectItem value="nurse">Infirmier(ère)</SelectItem>
// //                     <SelectItem value="caregiver">Aide-soignant(e)</SelectItem>
// //                     <SelectItem value="établissement de santé">Établissement de santé</SelectItem>
// //                   </SelectContent>
// //                 </Select>
// //               </div>

// //               {isEstablishment && (
// //                 <>
// //                   <div className="space-y-2 mt-4">
// //                     <Label className="text-amber-900">Type de tarification</Label>
// //                     <div>
// //                       <label className="inline-flex items-center mr-6">
// //                         <input
// //                           type="radio"
// //                           name="type_tarification"
// //                           value="fixe"
// //                           checked={formData.type_tarification === 'fixe'}
// //                           onChange={(e) => setFormData({ ...formData, type_tarification: e.target.value })}
// //                         />
// //                         <span className="ml-2">Tarification fixe</span>
// //                       </label>
// //                       <label className="inline-flex items-center">
// //                         <input
// //                           type="radio"
// //                           name="type_tarification"
// //                           value="pourcentage"
// //                           checked={formData.type_tarification === 'pourcentage'}
// //                           onChange={(e) => setFormData({ ...formData, type_tarification: e.target.value })}
// //                         />
// //                         <span className="ml-2">Tarification en pourcentage</span>
// //                       </label>
// //                     </div>
// //                   </div>

// //                   {formData.type_tarification === 'fixe' ? (
// //                     <div className="border border-amber-200 rounded-2xl p-4 bg-amber-50 mt-4 space-y-6">
// //                       <h3 className="text-lg font-semibold text-amber-800 flex items-center gap-2">
// //                         <Euro size={20} /> Tarification Infirmier
// //                       </h3>
// //                       <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
// //                         {Object.entries(formData.tarification.infirmier).map(([key, val]) => (
// //                           <div key={key} className="space-y-1">
// //                             <Label>{key.replace(/_/g, ' ')}</Label>
// //                             <Input
// //                               name={key}
// //                               type="number"
// //                               value={val}
// //                               onChange={(e) => handleChange(e, 'infirmier')}
// //                               className="border-amber-300"
// //                               required
// //                             />
// //                           </div>
// //                         ))}
// //                       </div>

// //                       <h3 className="text-lg font-semibold text-amber-800 flex items-center gap-2 mt-6">
// //                         <Euro size={20} /> Tarification Aide-Soignant
// //                       </h3>
// //                       <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
// //                         {Object.entries(formData.tarification.aide_soignant).map(([key, val]) => (
// //                           <div key={key} className="space-y-1">
// //                             <Label>{key.replace(/_/g, ' ')}</Label>
// //                             <Input
// //                               name={key}
// //                               type="number"
// //                               value={val}
// //                               onChange={(e) => handleChange(e, 'aide_soignant')}
// //                               className="border-amber-300"
// //                               required
// //                             />
// //                           </div>
// //                         ))}
// //                       </div>
// //                     </div>
// //                   ) : (
// //                     <div className="border border-amber-200 rounded-2xl p-4 bg-amber-50 mt-4 space-y-6">
// //                       <h3 className="text-lg font-semibold text-amber-800 flex items-center gap-2">
// //                         <Euro size={20} /> Tarification (prix fixe et déplacement)
// //                       </h3>
// //                       <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
// //                         <div className="space-y-1">
// //                           <Label>Prix fixe</Label>
// //                           <Input
// //                             name="fixed_price"
// //                             type="number"
// //                             step="0.01"
// //                             min="0"
// //                             value={formData.tarification.fixed_price}
// //                             onChange={(e) => handleChange(e, 'tarification')}
// //                             className="border-amber-300"
// //                             required
// //                           />
// //                         </div>
// //                         <div className="space-y-1">
// //                           <Label>Frais de déplacement</Label>
// //                           <Input
// //                             name="travel_fee"
// //                             type="number"
// //                             step="0.01"
// //                             min="0"
// //                             value={formData.tarification.travel_fee}
// //                             onChange={(e) => handleChange(e, 'tarification')}
// //                             className="border-amber-300"
// //                             required
// //                           />
// //                         </div>
// //                       </div>
// //                     </div>
// //                   )}
// //                 </>
// //               )}



// //               <div className="mt-6 p-6 border-4 border-blue-500 rounded-xl bg-blue-50">
// //                 <Turnstile
// //                   key={resetKey}
// //                   siteKey="0x4AAAAAACvwuSQXWbsUBjjq"
// //                   onSuccess={(token) => {
// //                     console.log("✅ TOKEN:", token);
// //                     setCaptchaToken(token);
// //                   }}
// //                   onError={() => {
// //                     console.log("❌ CAPTCHA ERROR");
// //                     setCaptchaToken('');
// //                   }}
// //                   onExpire={() => {
// //                     console.log("⏳ CAPTCHA EXPIRED");
// //                     setCaptchaToken('');
// //                   }}
// //                 />
// //               </div>

// //               <Button
// //                 type="submit"
// //                 className="w-full btn-gold text-lg py-6"
// //                 disabled={loading}
// //               >
// //                 {loading ? 'Inscription...' : "S'inscrire"}
// //               </Button>
// //             </form>

// //             <div className="mt-6 text-center">
// //               <p className="text-sm text-gray-600">
// //                 Déjà un compte ?{' '}
// //                 <Link to="/login" className="text-amber-700 hover:text-amber-900 font-semibold">
// //                   Se connecter
// //                 </Link>
// //               </p>
// //             </div>
// //           </CardContent>
// //         </Card>
// //       </div>
// //     </div>
// //   );
// // }


// import React, { useState } from 'react';
// import { useAuth } from '../App';
// import { Link, useNavigate } from 'react-router-dom';
// import { Button } from '../components/ui/button';
// import { Input } from '../components/ui/input';
// import { Label } from '../components/ui/label';
// import {
//   Card,
//   CardContent,
//   CardDescription,
//   CardHeader,
//   CardTitle
// } from '../components/ui/card';
// import {
//   Select,
//   SelectContent,
//   SelectItem,
//   SelectTrigger,
//   SelectValue
// } from '../components/ui/select';
// import { toast } from 'sonner';
// import {
//   UserPlus,
//   Mail,
//   Lock,
//   User,
//   Phone,
//   MapPin,
//   Euro
// } from 'lucide-react';
// import { Turnstile } from '@marsidev/react-turnstile';

// export default function Register() {
//   const { axiosInstance } = useAuth();
//   const navigate = useNavigate();

//   const [loading, setLoading] = useState(false);
//   const [captchaToken, setCaptchaToken] = useState('');
//   const [resetKey, setResetKey] = useState(0);

//   const [formData, setFormData] = useState({
//     email: '',
//     password: '',
//     first_name: '',
//     last_name: '',
//     phone: '',
//     address: '',
//     role: 'nurse',
//     type_tarification: 'fixe',
//     tarification: {
//       fixed_price: '',
//       travel_fee: '',
//       infirmier: {
//         weekday_rate: '',
//         travel_weekday_fee: '',
//         weekend_rate: '',
//         travel_weekend_fee: '',
//         night_week_rate: '',
//         travel_night_week_fee: '',
//         night_weekend_rate: '',
//         travel_night_weekend_fee: '',
//       },
//       aide_soignant: {
//         weekday_rate: '',
//         travel_weekday_fee: '',
//         weekend_rate: '',
//         travel_weekend_fee: '',
//         night_week_rate: '',
//         travel_night_week_fee: '',
//         night_weekend_rate: '',
//         travel_night_weekend_fee: '',
//       }
//     }
//   });

//   const isEstablishment =
//     formData.role === 'établissement de santé';

//   const handleChange = (e, tarifType = null) => {
//     const { name, value } = e.target;

//     if (tarifType) {
//       if (
//         tarifType === 'tarification' &&
//         (name === 'fixed_price' || name === 'travel_fee')
//       ) {
//         setFormData({
//           ...formData,
//           tarification: {
//             ...formData.tarification,
//             [name]: value
//           }
//         });
//       } else {
//         setFormData({
//           ...formData,
//           tarification: {
//             ...formData.tarification,
//             [tarifType]: {
//               ...formData.tarification[tarifType],
//               [name]: value
//             }
//           }
//         });
//       }
//     } else {
//       setFormData({
//         ...formData,
//         [name]: value
//       });
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     console.log('🔍 Token avant submit:', captchaToken);

//     if (!captchaToken) {
//       toast.error('Veuillez valider le CAPTCHA.');
//       setLoading(false);
//       return;
//     }

//     if (
//       formData.role !== 'établissement de santé' &&
//       formData.first_name.trim() === ''
//     ) {
//       toast.error('Le prénom est obligatoire pour ce rôle.');
//       setLoading(false);
//       return;
//     }

//     if (formData.last_name.trim() === '') {
//       toast.error('Le nom est obligatoire.');
//       setLoading(false);
//       return;
//     }

//     try {
//       const cleanNumber = (val) =>
//         isNaN(parseFloat(val)) ? 0 : parseFloat(val);

//       const tarifInfirmier =
//         formData.tarification.infirmier || {};

//       const tarifAide =
//         formData.tarification.aide_soignant || {};

//       let tarificationPayload = {};

//       if (formData.type_tarification === 'fixe') {
//         tarificationPayload = {
//           infirmier: {
//             weekday_rate: cleanNumber(
//               tarifInfirmier.weekday_rate
//             ),
//             travel_weekday_fee: cleanNumber(
//               tarifInfirmier.travel_weekday_fee
//             ),
//             weekend_rate: cleanNumber(
//               tarifInfirmier.weekend_rate
//             ),
//             travel_weekend_fee: cleanNumber(
//               tarifInfirmier.travel_weekend_fee
//             ),
//             night_week_rate: cleanNumber(
//               tarifInfirmier.night_week_rate
//             ),
//             travel_night_week_fee: cleanNumber(
//               tarifInfirmier.travel_night_week_fee
//             ),
//             night_weekend_rate: cleanNumber(
//               tarifInfirmier.night_weekend_rate
//             ),
//             travel_night_weekend_fee: cleanNumber(
//               tarifInfirmier.travel_night_weekend_fee
//             ),
//           },

//           aide_soignant: {
//             weekday_rate: cleanNumber(
//               tarifAide.weekday_rate
//             ),
//             travel_weekday_fee: cleanNumber(
//               tarifAide.travel_weekday_fee
//             ),
//             weekend_rate: cleanNumber(
//               tarifAide.weekend_rate
//             ),
//             travel_weekend_fee: cleanNumber(
//               tarifAide.travel_weekend_fee
//             ),
//             night_week_rate: cleanNumber(
//               tarifAide.night_week_rate
//             ),
//             travel_night_week_fee: cleanNumber(
//               tarifAide.travel_night_week_fee
//             ),
//             night_weekend_rate: cleanNumber(
//               tarifAide.night_weekend_rate
//             ),
//             travel_night_weekend_fee: cleanNumber(
//               tarifAide.travel_night_weekend_fee
//             ),
//           }
//         };
//       } else {
//         const fixedPrice = cleanNumber(
//           formData.tarification.fixed_price
//         );

//         const travelFee = cleanNumber(
//           formData.tarification.travel_fee
//         );

//         const zeroFields = {
//           weekend_rate: 0,
//           travel_weekend_fee: 0,
//           night_week_rate: 0,
//           travel_night_week_fee: 0,
//           night_weekend_rate: 0,
//           travel_night_weekend_fee: 0,
//         };

//         tarificationPayload = {
//           infirmier: {
//             weekday_rate: fixedPrice,
//             travel_weekday_fee: travelFee,
//             ...zeroFields
//           },
//           aide_soignant: {
//             weekday_rate: fixedPrice,
//             travel_weekday_fee: travelFee,
//             ...zeroFields
//           }
//         };
//       }

//       const payload = {
//         email: formData.email,
//         password: formData.password,
//         first_name: formData.first_name,
//         last_name: formData.last_name,
//         phone: formData.phone,
//         address: formData.address,
//         role: formData.role,
//         type_tarification: formData.type_tarification,
//         tarification: tarificationPayload,
//         captcha_token: captchaToken,
//       };

//       await axiosInstance.post('/auth/register', payload);

//       toast.success(
//         "Inscription réussie ! Attendez l'approbation de l'administrateur."
//       );

//       navigate('/login');
//     } catch (error) {
//       let message = "Échec de l'inscription";

//       if (error.response?.data?.detail) {
//         const detail = error.response.data.detail;

//         if (Array.isArray(detail)) {
//           message = detail.map((d) => d.msg).join(', ');
//         } else if (typeof detail === 'string') {
//           message = detail;
//         } else if (
//           typeof detail === 'object' &&
//           detail.msg
//         ) {
//           message = detail.msg;
//         } else {
//           message = JSON.stringify(detail);
//         }
//       }

//       toast.error(message);
//     } finally {
//       setLoading(false);
//       setCaptchaToken('');
//       setResetKey((prev) => prev + 1);
//     }
//   };

//   return (
//     <div
//       className="min-h-screen flex items-center justify-center p-4"
//       style={{
//         background:
//           'linear-gradient(135deg, #F5FAFA 0%, #D4EBEB 50%, #EEF7F7 100%)'
//       }}
//     >
//       <div className="w-full max-w-2xl">

//         {/* Logo / Header */}
//         <div className="text-center mb-8 fade-in">
//           <h1
//             className="text-5xl font-bold mb-2"
//             style={{
//               fontFamily: 'Playfair Display, serif',
//               color: '#356B6B'
//             }}
//           >
//             Sana-Care
//           </h1>

//           <p
//             className="text-lg font-medium"
//             style={{ color: '#5A8F8F' }}
//           >
//             Rejoignez notre équipe
//           </p>
//         </div>

//         {/* Carte */}
//         <Card
//           className="bg-white/95 backdrop-blur-sm shadow-xl relative"
//           style={{
//             borderColor: '#C5DFDF',
//             zIndex: 50
//           }}
//         >
//           <CardHeader>
//             <CardTitle
//               className="text-2xl text-center"
//               style={{ color: '#356B6B' }}
//             >
//               <UserPlus
//                 className="inline mr-2 mb-1"
//                 size={28}
//                 style={{ color: '#5A8F8F' }}
//               />
//               Inscription
//             </CardTitle>

//             <CardDescription className="text-center text-gray-500">
//               Créez votre compte professionnel
//             </CardDescription>
//           </CardHeader>

//           <CardContent>
//             <form
//               onSubmit={handleSubmit}
//               className="space-y-4"
//             >

//               {/* Prénom */}
//               {!isEstablishment && (
//                 <div className="space-y-2">
//                   <Label
//                     htmlFor="first_name"
//                     className="font-medium"
//                     style={{ color: '#356B6B' }}
//                   >
//                     Prénom
//                   </Label>

//                   <div className="relative">
//                     <User
//                       className="absolute left-3 top-3"
//                       size={20}
//                       style={{ color: '#5A8F8F' }}
//                     />

//                     <Input
//                       id="first_name"
//                       name="first_name"
//                       placeholder="Jean"
//                       value={formData.first_name}
//                       onChange={handleChange}
//                       required={!isEstablishment}
//                       className="pl-10 bg-white"
//                       style={{ borderColor: '#C5DFDF' }}
//                     />
//                   </div>
//                 </div>
//               )}

//               {/* Nom */}
//               <div className="space-y-2">
//                 <Label
//                   htmlFor="last_name"
//                   className="font-medium"
//                   style={{ color: '#356B6B' }}
//                 >
//                   Nom
//                 </Label>

//                 <div className="relative">
//                   <User
//                     className="absolute left-3 top-3"
//                     size={20}
//                     style={{ color: '#5A8F8F' }}
//                   />

//                   <Input
//                     id="last_name"
//                     name="last_name"
//                     placeholder="Dupont"
//                     value={formData.last_name}
//                     onChange={handleChange}
//                     required
//                     className="pl-10 bg-white"
//                     style={{ borderColor: '#C5DFDF' }}
//                   />
//                 </div>
//               </div>

//               {/* Email */}
//               <div className="space-y-2">
//                 <Label
//                   htmlFor="email"
//                   className="font-medium"
//                   style={{ color: '#356B6B' }}
//                 >
//                   Email
//                 </Label>

//                 <div className="relative">
//                   <Mail
//                     className="absolute left-3 top-3"
//                     size={20}
//                     style={{ color: '#5A8F8F' }}
//                   />

//                   <Input
//                     id="email"
//                     name="email"
//                     type="email"
//                     placeholder="exemple@gmail.com"
//                     value={formData.email}
//                     onChange={handleChange}
//                     required
//                     className="pl-10 bg-white"
//                     style={{ borderColor: '#C5DFDF' }}
//                   />
//                 </div>
//               </div>

//               {/* Mot de passe */}
//               <div className="space-y-2">
//                 <Label
//                   htmlFor="password"
//                   className="font-medium"
//                   style={{ color: '#356B6B' }}
//                 >
//                   Mot de passe
//                 </Label>

//                 <div className="relative">
//                   <Lock
//                     className="absolute left-3 top-3"
//                     size={20}
//                     style={{ color: '#5A8F8F' }}
//                   />

//                   <Input
//                     id="password"
//                     name="password"
//                     type="password"
//                     placeholder="••••••••"
//                     value={formData.password}
//                     onChange={handleChange}
//                     required
//                     className="pl-10 bg-white"
//                     style={{ borderColor: '#C5DFDF' }}
//                   />
//                 </div>
//               </div>

//               {/* Téléphone */}
//               <div className="space-y-2">
//                 <Label
//                   htmlFor="phone"
//                   className="font-medium"
//                   style={{ color: '#356B6B' }}
//                 >
//                   Téléphone
//                 </Label>

//                 <div className="relative">
//                   <Phone
//                     className="absolute left-3 top-3"
//                     size={20}
//                     style={{ color: '#5A8F8F' }}
//                   />

//                   <Input
//                     id="phone"
//                     name="phone"
//                     placeholder="+32 000000000"
//                     value={formData.phone}
//                     onChange={handleChange}
//                     required
//                     className="pl-10 bg-white"
//                     style={{ borderColor: '#C5DFDF' }}
//                   />
//                 </div>
//               </div>

//               {/* Adresse */}
//               <div className="space-y-2">
//                 <Label
//                   htmlFor="address"
//                   className="font-medium"
//                   style={{ color: '#356B6B' }}
//                 >
//                   Adresse
//                 </Label>

//                 <div className="relative">
//                   <MapPin
//                     className="absolute left-3 top-3"
//                     size={20}
//                     style={{ color: '#5A8F8F' }}
//                   />

//                   <Input
//                     id="address"
//                     name="address"
//                     placeholder="123 Rue de la Santé, Bruxelles"
//                     value={formData.address}
//                     onChange={handleChange}
//                     required
//                     className="pl-10 bg-white"
//                     style={{ borderColor: '#C5DFDF' }}
//                   />
//                 </div>
//               </div>

//               {/* Rôle */}
//               <div className="space-y-2">
//                 <Label
//                   htmlFor="role"
//                   className="font-medium"
//                   style={{ color: '#356B6B' }}
//                 >
//                   Rôle
//                 </Label>

//                 <Select
//                   value={formData.role}
//                   onValueChange={(value) =>
//                     setFormData({
//                       ...formData,
//                       role: value
//                     })
//                   }
//                 >
//                   <SelectTrigger
//                     className="bg-white"
//                     style={{ borderColor: '#C5DFDF' }}
//                   >
//                     <SelectValue placeholder="Choisissez un rôle" />
//                   </SelectTrigger>

//                   <SelectContent>
//                     <SelectItem value="nurse">
//                       Infirmier(ère)
//                     </SelectItem>

//                     <SelectItem value="caregiver">
//                       Aide-soignant(e)
//                     </SelectItem>

//                     <SelectItem value="établissement de santé">
//                       Établissement de santé
//                     </SelectItem>
//                   </SelectContent>
//                 </Select>
//               </div>

//               {/* Tarification établissement */}
//               {isEstablishment && (
//                 <>
//                   <div className="space-y-2 mt-4">
//                     <Label
//                       className="font-medium"
//                       style={{ color: '#356B6B' }}
//                     >
//                       Type de tarification
//                     </Label>

//                     <div className="flex flex-wrap gap-6">
//                       <label className="inline-flex items-center">
//                         <input
//                           type="radio"
//                           name="type_tarification"
//                           value="fixe"
//                           checked={
//                             formData.type_tarification === 'fixe'
//                           }
//                           onChange={(e) =>
//                             setFormData({
//                               ...formData,
//                               type_tarification: e.target.value
//                             })
//                           }
//                           className="accent-[#5A8F8F]"
//                         />

//                         <span className="ml-2 text-gray-700">
//                           Tarification fixe
//                         </span>
//                       </label>

//                       <label className="inline-flex items-center">
//                         <input
//                           type="radio"
//                           name="type_tarification"
//                           value="pourcentage"
//                           checked={
//                             formData.type_tarification ===
//                             'pourcentage'
//                           }
//                           onChange={(e) =>
//                             setFormData({
//                               ...formData,
//                               type_tarification: e.target.value
//                             })
//                           }
//                           className="accent-[#5A8F8F]"
//                         />

//                         <span className="ml-2 text-gray-700">
//                           Tarification en pourcentage
//                         </span>
//                       </label>
//                     </div>
//                   </div>

//                   {/* Tarification fixe */}
//                   {formData.type_tarification === 'fixe' ? (
//                     <div
//                       className="rounded-2xl p-4 mt-4 space-y-6"
//                       style={{
//                         border: '1px solid #C5DFDF',
//                         backgroundColor: '#F5FAFA'
//                       }}
//                     >
//                       <h3
//                         className="text-lg font-semibold flex items-center gap-2"
//                         style={{ color: '#356B6B' }}
//                       >
//                         <Euro size={20} />
//                         Tarification Infirmier
//                       </h3>

//                       <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                         {Object.entries(
//                           formData.tarification.infirmier
//                         ).map(([key, val]) => (
//                           <div
//                             key={key}
//                             className="space-y-1"
//                           >
//                             <Label className="text-gray-700">
//                               {key.replace(/_/g, ' ')}
//                             </Label>

//                             <Input
//                               name={key}
//                               type="number"
//                               value={val}
//                               onChange={(e) =>
//                                 handleChange(e, 'infirmier')
//                               }
//                               className="bg-white"
//                               style={{
//                                 borderColor: '#C5DFDF'
//                               }}
//                               required
//                             />
//                           </div>
//                         ))}
//                       </div>

//                       <h3
//                         className="text-lg font-semibold flex items-center gap-2 mt-6"
//                         style={{ color: '#356B6B' }}
//                       >
//                         <Euro size={20} />
//                         Tarification Aide-Soignant
//                       </h3>

//                       <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                         {Object.entries(
//                           formData.tarification.aide_soignant
//                         ).map(([key, val]) => (
//                           <div
//                             key={key}
//                             className="space-y-1"
//                           >
//                             <Label className="text-gray-700">
//                               {key.replace(/_/g, ' ')}
//                             </Label>

//                             <Input
//                               name={key}
//                               type="number"
//                               value={val}
//                               onChange={(e) =>
//                                 handleChange(e, 'aide_soignant')
//                               }
//                               className="bg-white"
//                               style={{
//                                 borderColor: '#C5DFDF'
//                               }}
//                               required
//                             />
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   ) : (
//                     /* Tarification pourcentage */
//                     <div
//                       className="rounded-2xl p-4 mt-4 space-y-6"
//                       style={{
//                         border: '1px solid #C5DFDF',
//                         backgroundColor: '#F5FAFA'
//                       }}
//                     >
//                       <h3
//                         className="text-lg font-semibold flex items-center gap-2"
//                         style={{ color: '#356B6B' }}
//                       >
//                         <Euro size={20} />
//                         Tarification (prix fixe et déplacement)
//                       </h3>

//                       <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                         <div className="space-y-1">
//                           <Label className="text-gray-700">
//                             Prix fixe
//                           </Label>

//                           <Input
//                             name="fixed_price"
//                             type="number"
//                             step="0.01"
//                             min="0"
//                             value={
//                               formData.tarification.fixed_price
//                             }
//                             onChange={(e) =>
//                               handleChange(e, 'tarification')
//                             }
//                             className="bg-white"
//                             style={{
//                               borderColor: '#C5DFDF'
//                             }}
//                             required
//                           />
//                         </div>

//                         <div className="space-y-1">
//                           <Label className="text-gray-700">
//                             Frais de déplacement
//                           </Label>

//                           <Input
//                             name="travel_fee"
//                             type="number"
//                             step="0.01"
//                             min="0"
//                             value={
//                               formData.tarification.travel_fee
//                             }
//                             onChange={(e) =>
//                               handleChange(e, 'tarification')
//                             }
//                             className="bg-white"
//                             style={{
//                               borderColor: '#C5DFDF'
//                             }}
//                             required
//                           />
//                         </div>
//                       </div>
//                     </div>
//                   )}
//                 </>
//               )}

//               {/* CAPTCHA */}
//               <div
//                 className="mt-6 p-6 rounded-xl flex justify-center"
//                 style={{
//                   border: '2px solid #C5DFDF',
//                   backgroundColor: '#F5FAFA'
//                 }}
//               >
//                 <Turnstile
//                   key={resetKey}
//                   siteKey="0x4AAAAAACvwuSQXWbsUBjjq"
//                   onSuccess={(token) => {
//                     console.log('✅ TOKEN:', token);
//                     setCaptchaToken(token);
//                   }}
//                   onError={() => {
//                     console.log('❌ CAPTCHA ERROR');
//                     setCaptchaToken('');
//                   }}
//                   onExpire={() => {
//                     console.log('⏳ CAPTCHA EXPIRED');
//                     setCaptchaToken('');
//                   }}
//                 />
//               </div>

//               {/* Bouton */}
//               <Button
//                 type="submit"
//                 className="w-full text-lg py-6 text-white shadow-md transition-all"
//                 style={{
//                   backgroundColor: '#5A8F8F'
//                 }}
//                 onMouseEnter={(e) => {
//                   e.currentTarget.style.backgroundColor =
//                     '#356B6B';
//                 }}
//                 onMouseLeave={(e) => {
//                   e.currentTarget.style.backgroundColor =
//                     '#5A8F8F';
//                 }}
//                 disabled={loading}
//               >
//                 {loading ? 'Inscription...' : "S'inscrire"}
//               </Button>
//             </form>

//             {/* Connexion */}
//             <div className="mt-6 text-center">
//               <p className="text-sm text-gray-500">
//                 Déjà un compte ?{' '}

//                 <Link
//                   to="/login"
//                   className="font-semibold transition-colors"
//                   style={{ color: '#356B6B' }}
//                   onMouseEnter={(e) => {
//                     e.currentTarget.style.color = '#5A8F8F';
//                   }}
//                   onMouseLeave={(e) => {
//                     e.currentTarget.style.color = '#356B6B';
//                   }}
//                 >
//                   Se connecter
//                 </Link>
//               </p>
//             </div>
//           </CardContent>
//         </Card>
//       </div>
//     </div>
//   );
// }




import React, { useState } from 'react';
import { useAuth } from '../App';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle
} from '../components/ui/card';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '../components/ui/select';
import { toast } from 'sonner';
import {
  UserPlus,
  Mail,
  Lock,
  User,
  Phone,
  MapPin,
  Euro
} from 'lucide-react';
import { Turnstile } from '@marsidev/react-turnstile';

export default function Register() {
  const { axiosInstance } = useAuth();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [captchaToken, setCaptchaToken] = useState('');
  const [resetKey, setResetKey] = useState(0);

  const [formData, setFormData] = useState({
    email: '',
    password: '',
    first_name: '',
    last_name: '',
    phone: '',
    address: '',
    role: 'nurse',
    type_tarification: 'fixe',
    tarification: {
      fixed_price: '',
      travel_fee: '',
      infirmier: {
        weekday_rate: '',
        travel_weekday_fee: '',
        weekend_rate: '',
        travel_weekend_fee: '',
        night_week_rate: '',
        travel_night_week_fee: '',
        night_weekend_rate: '',
        travel_night_weekend_fee: '',
      },
      aide_soignant: {
        weekday_rate: '',
        travel_weekday_fee: '',
        weekend_rate: '',
        travel_weekend_fee: '',
        night_week_rate: '',
        travel_night_week_fee: '',
        night_weekend_rate: '',
        travel_night_weekend_fee: '',
      }
    }
  });

  const isEstablishment =
    formData.role === 'établissement de santé';

  const handleChange = (e, tarifType = null) => {
    const { name, value } = e.target;

    if (tarifType) {
      if (
        tarifType === 'tarification' &&
        (name === 'fixed_price' || name === 'travel_fee')
      ) {
        setFormData({
          ...formData,
          tarification: {
            ...formData.tarification,
            [name]: value
          }
        });
      } else {
        setFormData({
          ...formData,
          tarification: {
            ...formData.tarification,
            [tarifType]: {
              ...formData.tarification[tarifType],
              [name]: value
            }
          }
        });
      }
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    console.log('🔍 Token avant submit:', captchaToken);

    if (!captchaToken) {
      toast.error('Veuillez valider le CAPTCHA.');
      setLoading(false);
      return;
    }

    if (
      formData.role !== 'établissement de santé' &&
      formData.first_name.trim() === ''
    ) {
      toast.error('Le prénom est obligatoire pour ce rôle.');
      setLoading(false);
      return;
    }

    if (formData.last_name.trim() === '') {
      toast.error('Le nom est obligatoire.');
      setLoading(false);
      return;
    }

    try {
      const cleanNumber = (val) =>
        isNaN(parseFloat(val)) ? 0 : parseFloat(val);

      const tarifInfirmier =
        formData.tarification.infirmier || {};

      const tarifAide =
        formData.tarification.aide_soignant || {};

      let tarificationPayload = {};

      if (formData.type_tarification === 'fixe') {
        tarificationPayload = {
          infirmier: {
            weekday_rate: cleanNumber(
              tarifInfirmier.weekday_rate
            ),
            travel_weekday_fee: cleanNumber(
              tarifInfirmier.travel_weekday_fee
            ),
            weekend_rate: cleanNumber(
              tarifInfirmier.weekend_rate
            ),
            travel_weekend_fee: cleanNumber(
              tarifInfirmier.travel_weekend_fee
            ),
            night_week_rate: cleanNumber(
              tarifInfirmier.night_week_rate
            ),
            travel_night_week_fee: cleanNumber(
              tarifInfirmier.travel_night_week_fee
            ),
            night_weekend_rate: cleanNumber(
              tarifInfirmier.night_weekend_rate
            ),
            travel_night_weekend_fee: cleanNumber(
              tarifInfirmier.travel_night_weekend_fee
            ),
          },

          aide_soignant: {
            weekday_rate: cleanNumber(
              tarifAide.weekday_rate
            ),
            travel_weekday_fee: cleanNumber(
              tarifAide.travel_weekday_fee
            ),
            weekend_rate: cleanNumber(
              tarifAide.weekend_rate
            ),
            travel_weekend_fee: cleanNumber(
              tarifAide.travel_weekend_fee
            ),
            night_week_rate: cleanNumber(
              tarifAide.night_week_rate
            ),
            travel_night_week_fee: cleanNumber(
              tarifAide.travel_night_week_fee
            ),
            night_weekend_rate: cleanNumber(
              tarifAide.night_weekend_rate
            ),
            travel_night_weekend_fee: cleanNumber(
              tarifAide.travel_night_weekend_fee
            ),
          }
        };
      } else {
        const fixedPrice = cleanNumber(
          formData.tarification.fixed_price
        );

        const travelFee = cleanNumber(
          formData.tarification.travel_fee
        );

        const zeroFields = {
          weekend_rate: 0,
          travel_weekend_fee: 0,
          night_week_rate: 0,
          travel_night_week_fee: 0,
          night_weekend_rate: 0,
          travel_night_weekend_fee: 0,
        };

        tarificationPayload = {
          infirmier: {
            weekday_rate: fixedPrice,
            travel_weekday_fee: travelFee,
            ...zeroFields
          },
          aide_soignant: {
            weekday_rate: fixedPrice,
            travel_weekday_fee: travelFee,
            ...zeroFields
          }
        };
      }

      const payload = {
        email: formData.email,
        password: formData.password,
        first_name: formData.first_name,
        last_name: formData.last_name,
        phone: formData.phone,
        address: formData.address,
        role: formData.role,
        type_tarification: formData.type_tarification,
        tarification: tarificationPayload,
        captcha_token: captchaToken,
      };

      await axiosInstance.post('/auth/register', payload);

      toast.success(
        "Inscription réussie ! Attendez l'approbation de l'administrateur."
      );

      navigate('/login');
    } catch (error) {
      let message = "Échec de l'inscription";

      if (error.response?.data?.detail) {
        const detail = error.response.data.detail;

        if (Array.isArray(detail)) {
          message = detail.map((d) => d.msg).join(', ');
        } else if (typeof detail === 'string') {
          message = detail;
        } else if (
          typeof detail === 'object' &&
          detail.msg
        ) {
          message = detail.msg;
        } else {
          message = JSON.stringify(detail);
        }
      }

      toast.error(message);
    } finally {
      setLoading(false);
      setCaptchaToken('');
      setResetKey((prev) => prev + 1);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center p-4"
      style={{
        background:
          'linear-gradient(135deg, #F5FAFA 0%, #D4EBEB 50%, #EEF7F7 100%)'
      }}
    >
      <div className="w-full max-w-2xl">

        {/* Logo / Header */}
        <div className="text-center mb-8 fade-in">
          <h1
            className="text-5xl font-bold mb-2"
            style={{
              fontFamily: 'Playfair Display, serif',
              color: '#356B6B'
            }}
          >
            Sana-Care
          </h1>

          <p
            className="text-lg font-medium"
            style={{ color: '#5A8F8F' }}
          >
            Rejoignez notre équipe
          </p>
        </div>

        {/* Carte */}
        <Card
          className="bg-white/95 backdrop-blur-sm shadow-xl relative"
          style={{
            borderColor: '#C5DFDF',
            zIndex: 50
          }}
        >
          <CardHeader>
            <CardTitle
              className="text-2xl text-center"
              style={{ color: '#356B6B' }}
            >
              <UserPlus
                className="inline mr-2 mb-1"
                size={28}
                style={{ color: '#5A8F8F' }}
              />
              Inscription
            </CardTitle>

            <CardDescription className="text-center text-gray-500">
              Créez votre compte professionnel
            </CardDescription>
          </CardHeader>

          <CardContent>
            <form
              onSubmit={handleSubmit}
              className="space-y-4"
            >

              {/* Prénom */}
              {!isEstablishment && (
                <div className="space-y-2">
                  <Label
                    htmlFor="first_name"
                    className="font-medium"
                    style={{ color: '#356B6B' }}
                  >
                    Prénom
                  </Label>

                  <div className="relative">
                    <User
                      className="absolute left-3 top-3"
                      size={20}
                      style={{ color: '#5A8F8F' }}
                    />

                    <Input
                      id="first_name"
                      name="first_name"
                      placeholder="Jean"
                      value={formData.first_name}
                      onChange={handleChange}
                      required={!isEstablishment}
                      className="pl-10 bg-white"
                      style={{ borderColor: '#C5DFDF' }}
                    />
                  </div>
                </div>
              )}

              {/* Nom */}
              <div className="space-y-2">
                <Label
                  htmlFor="last_name"
                  className="font-medium"
                  style={{ color: '#356B6B' }}
                >
                  Nom
                </Label>

                <div className="relative">
                  <User
                    className="absolute left-3 top-3"
                    size={20}
                    style={{ color: '#5A8F8F' }}
                  />

                  <Input
                    id="last_name"
                    name="last_name"
                    placeholder="Dupont"
                    value={formData.last_name}
                    onChange={handleChange}
                    required
                    className="pl-10 bg-white"
                    style={{ borderColor: '#C5DFDF' }}
                  />
                </div>
              </div>

              {/* Email */}
              <div className="space-y-2">
                <Label
                  htmlFor="email"
                  className="font-medium"
                  style={{ color: '#356B6B' }}
                >
                  Email
                </Label>

                <div className="relative">
                  <Mail
                    className="absolute left-3 top-3"
                    size={20}
                    style={{ color: '#5A8F8F' }}
                  />

                  <Input
                    id="email"
                    name="email"
                    type="email"
                    placeholder="exemple@gmail.com"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="pl-10 bg-white"
                    style={{ borderColor: '#C5DFDF' }}
                  />
                </div>
              </div>

              {/* Mot de passe */}
              <div className="space-y-2">
                <Label
                  htmlFor="password"
                  className="font-medium"
                  style={{ color: '#356B6B' }}
                >
                  Mot de passe
                </Label>

                <div className="relative">
                  <Lock
                    className="absolute left-3 top-3"
                    size={20}
                    style={{ color: '#5A8F8F' }}
                  />

                  <Input
                    id="password"
                    name="password"
                    type="password"
                    placeholder="••••••••"
                    value={formData.password}
                    onChange={handleChange}
                    required
                    className="pl-10 bg-white"
                    style={{ borderColor: '#C5DFDF' }}
                  />
                </div>
              </div>

              {/* Téléphone */}
              <div className="space-y-2">
                <Label
                  htmlFor="phone"
                  className="font-medium"
                  style={{ color: '#356B6B' }}
                >
                  Téléphone
                </Label>

                <div className="relative">
                  <Phone
                    className="absolute left-3 top-3"
                    size={20}
                    style={{ color: '#5A8F8F' }}
                  />

                  <Input
                    id="phone"
                    name="phone"
                    placeholder="+32 000000000"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    className="pl-10 bg-white"
                    style={{ borderColor: '#C5DFDF' }}
                  />
                </div>
              </div>

              {/* Adresse */}
              <div className="space-y-2">
                <Label
                  htmlFor="address"
                  className="font-medium"
                  style={{ color: '#356B6B' }}
                >
                  Adresse
                </Label>

                <div className="relative">
                  <MapPin
                    className="absolute left-3 top-3"
                    size={20}
                    style={{ color: '#5A8F8F' }}
                  />

                  <Input
                    id="address"
                    name="address"
                    placeholder="123 Rue de la Santé, Bruxelles"
                    value={formData.address}
                    onChange={handleChange}
                    required
                    className="pl-10 bg-white"
                    style={{ borderColor: '#C5DFDF' }}
                  />
                </div>
              </div>

              {/* Rôle */}
              <div className="space-y-2">
                <Label
                  htmlFor="role"
                  className="font-medium"
                  style={{ color: '#356B6B' }}
                >
                  Rôle
                </Label>

                <Select
                  value={formData.role}
                  onValueChange={(value) =>
                    setFormData({
                      ...formData,
                      role: value
                    })
                  }
                >
                  <SelectTrigger
                    className="bg-white"
                    style={{ borderColor: '#C5DFDF' }}
                  >
                    <SelectValue placeholder="Choisissez un rôle" />
                  </SelectTrigger>

                  <SelectContent>
                    <SelectItem value="nurse">
                      Infirmier(ère)
                    </SelectItem>

                    <SelectItem value="caregiver">
                      Aide-soignant(e)
                    </SelectItem>

                    <SelectItem value="établissement de santé">
                      Établissement de santé
                    </SelectItem>

                    <SelectItem value="titulaire_domicile">
                      Titulaire – Soins à domicile
                    </SelectItem>
                  </SelectContent>
                </Select>
              </div>

              {/* Tarification établissement */}
              {isEstablishment && (
                <>
                  <div className="space-y-2 mt-4">
                    <Label
                      className="font-medium"
                      style={{ color: '#356B6B' }}
                    >
                      Type de tarification
                    </Label>

                    <div className="flex flex-wrap gap-6">
                      <label className="inline-flex items-center">
                        <input
                          type="radio"
                          name="type_tarification"
                          value="fixe"
                          checked={
                            formData.type_tarification === 'fixe'
                          }
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              type_tarification: e.target.value
                            })
                          }
                          className="accent-[#5A8F8F]"
                        />

                        <span className="ml-2 text-gray-700">
                          Tarification fixe
                        </span>
                      </label>

                      <label className="inline-flex items-center">
                        <input
                          type="radio"
                          name="type_tarification"
                          value="pourcentage"
                          checked={
                            formData.type_tarification ===
                            'pourcentage'
                          }
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              type_tarification: e.target.value
                            })
                          }
                          className="accent-[#5A8F8F]"
                        />

                        <span className="ml-2 text-gray-700">
                          Tarification en pourcentage
                        </span>
                      </label>
                    </div>
                  </div>

                  {/* Tarification fixe */}
                  {formData.type_tarification === 'fixe' ? (
                    <div
                      className="rounded-2xl p-4 mt-4 space-y-6"
                      style={{
                        border: '1px solid #C5DFDF',
                        backgroundColor: '#F5FAFA'
                      }}
                    >
                      <h3
                        className="text-lg font-semibold flex items-center gap-2"
                        style={{ color: '#356B6B' }}
                      >
                        <Euro size={20} />
                        Tarification Infirmier
                      </h3>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {Object.entries(
                          formData.tarification.infirmier
                        ).map(([key, val]) => (
                          <div
                            key={key}
                            className="space-y-1"
                          >
                            <Label className="text-gray-700">
                              {key.replace(/_/g, ' ')}
                            </Label>

                            <Input
                              name={key}
                              type="number"
                              value={val}
                              onChange={(e) =>
                                handleChange(e, 'infirmier')
                              }
                              className="bg-white"
                              style={{
                                borderColor: '#C5DFDF'
                              }}
                              required
                            />
                          </div>
                        ))}
                      </div>

                      <h3
                        className="text-lg font-semibold flex items-center gap-2 mt-6"
                        style={{ color: '#356B6B' }}
                      >
                        <Euro size={20} />
                        Tarification Aide-Soignant
                      </h3>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {Object.entries(
                          formData.tarification.aide_soignant
                        ).map(([key, val]) => (
                          <div
                            key={key}
                            className="space-y-1"
                          >
                            <Label className="text-gray-700">
                              {key.replace(/_/g, ' ')}
                            </Label>

                            <Input
                              name={key}
                              type="number"
                              value={val}
                              onChange={(e) =>
                                handleChange(e, 'aide_soignant')
                              }
                              className="bg-white"
                              style={{
                                borderColor: '#C5DFDF'
                              }}
                              required
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  ) : (
                    /* Tarification pourcentage */
                    <div
                      className="rounded-2xl p-4 mt-4 space-y-6"
                      style={{
                        border: '1px solid #C5DFDF',
                        backgroundColor: '#F5FAFA'
                      }}
                    >
                      <h3
                        className="text-lg font-semibold flex items-center gap-2"
                        style={{ color: '#356B6B' }}
                      >
                        <Euro size={20} />
                        Tarification (prix fixe et déplacement)
                      </h3>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div className="space-y-1">
                          <Label className="text-gray-700">
                            Prix fixe
                          </Label>

                          <Input
                            name="fixed_price"
                            type="number"
                            step="0.01"
                            min="0"
                            value={
                              formData.tarification.fixed_price
                            }
                            onChange={(e) =>
                              handleChange(e, 'tarification')
                            }
                            className="bg-white"
                            style={{
                              borderColor: '#C5DFDF'
                            }}
                            required
                          />
                        </div>

                        <div className="space-y-1">
                          <Label className="text-gray-700">
                            Frais de déplacement
                          </Label>

                          <Input
                            name="travel_fee"
                            type="number"
                            step="0.01"
                            min="0"
                            value={
                              formData.tarification.travel_fee
                            }
                            onChange={(e) =>
                              handleChange(e, 'tarification')
                            }
                            className="bg-white"
                            style={{
                              borderColor: '#C5DFDF'
                            }}
                            required
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}

              {/* CAPTCHA */}
              <div
                className="mt-6 p-6 rounded-xl flex justify-center"
                style={{
                  border: '2px solid #C5DFDF',
                  backgroundColor: '#F5FAFA'
                }}
              >
                <Turnstile
                  key={resetKey}
                  siteKey="0x4AAAAAACvwuSQXWbsUBjjq"
                  onSuccess={(token) => {
                    console.log('✅ TOKEN:', token);
                    setCaptchaToken(token);
                  }}
                  onError={() => {
                    console.log('❌ CAPTCHA ERROR');
                    setCaptchaToken('');
                  }}
                  onExpire={() => {
                    console.log('⏳ CAPTCHA EXPIRED');
                    setCaptchaToken('');
                  }}
                />
              </div>

              {/* Bouton */}
              <Button
                type="submit"
                className="w-full text-lg py-6 text-white shadow-md transition-all"
                style={{
                  backgroundColor: '#5A8F8F'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor =
                    '#356B6B';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor =
                    '#5A8F8F';
                }}
                disabled={loading}
              >
                {loading ? 'Inscription...' : "S'inscrire"}
              </Button>
            </form>

            {/* Connexion */}
            <div className="mt-6 text-center">
              <p className="text-sm text-gray-500">
                Déjà un compte ?{' '}

                <Link
                  to="/login"
                  className="font-semibold transition-colors"
                  style={{ color: '#356B6B' }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = '#5A8F8F';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = '#356B6B';
                  }}
                >
                  Se connecter
                </Link>
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}